import { FlexColumn } from '@gorila-shared-ui/components';
import { Modal, ModalBody, ModalHeader } from 'baseui/modal';
import { memo } from 'react';
import { createPortal } from 'react-dom';
import { useStyles } from '../../../hooks/useStyles';
import { AssetFilters } from '../AssetFilters';

type Props = {
  isOpen: boolean;
  monitoring?: boolean;
  selectedClientId?: string;
  selectedSubClientId?: string;
  onClose: () => void;
  setMonitoring: (monitoring?: boolean) => void;
  setSelectedClientId: (clientId?: string) => void;
  setSelectedSubClientId: (subClientId?: string) => void;
};

function AssetFiltersModal({
  isOpen,
  monitoring,
  selectedClientId,
  selectedSubClientId,
  onClose,
  setMonitoring,
  setSelectedClientId,
  setSelectedSubClientId,
}: Props) {
  const { css, theme } = useStyles();

  return createPortal(
    <Modal
      animate
      closeable
      onClose={onClose}
      isOpen={isOpen}
      size="auto"
    >
      <ModalHeader>Filtros</ModalHeader>
      <ModalBody>
        <FlexColumn
          gap={theme.sizing.scale300}
          classNames={css({ width: '70vw', maxWidth: '768px', boxSizing: 'border-box' })}
        >
          <AssetFilters
            monitoring={monitoring}
            selectedClientId={selectedClientId}
            selectedSubClientId={selectedSubClientId}
            setMonitoring={setMonitoring}
            setSelectedClientId={setSelectedClientId}
            setSelectedSubClientId={setSelectedSubClientId}
          />
        </FlexColumn>
      </ModalBody>
    </Modal>,
    document.body,
  );
}

export default memo(AssetFiltersModal);
